import axiosClient from "../../api/axiosClient";

const adminRequest = {
  __silentToast: true,
  __silent401: true,
  __silent403: true,
  __skipBizHeader: true,
};

function basePath(businessId, userId) {
  return `/admin/product-guidance/businesses/${encodeURIComponent(
    businessId
  )}/users/${encodeURIComponent(userId)}/states`;
}

export async function getAdminProductGuidanceStates(businessId, userId) {
  const response = await axiosClient.get(basePath(businessId, userId), adminRequest);
  return Array.isArray(response?.data) ? response.data : [];
}

export async function resetAdminProductGuidanceState(
  businessId,
  userId,
  experience
) {
  await axiosClient.post(
    `${basePath(businessId, userId)}/reset`,
    experience,
    adminRequest
  );
}

export async function forceAdminProductGuidanceReplay(
  businessId,
  userId,
  experience
) {
  const response = await axiosClient.post(
    `${basePath(businessId, userId)}/force-replay`,
    experience,
    adminRequest
  );
  return response?.data ?? null;
}
